import { render, staticRenderFns } from "./svcBalanceRangeComponent.vue?vue&type=template&id=51da2595&"
import script from "./svcBalanceRangeComponent.vue?vue&type=script&lang=js&"
export * from "./svcBalanceRangeComponent.vue?vue&type=script&lang=js&"
import style0 from "./svcBalanceRangeComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51da2595')) {
      api.createRecord('51da2595', component.options)
    } else {
      api.reload('51da2595', component.options)
    }
    module.hot.accept("./svcBalanceRangeComponent.vue?vue&type=template&id=51da2595&", function () {
      api.rerender('51da2595', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/svcManage/svcDiscount/svcBalanceRangeComponent.vue"
export default component.exports